import React from 'react'
import classnames from 'classnames'

import Module from '../../Module'
import Button from '../../Button'
import { connect } from 'react-redux'

import { closeModal } from '../../../../reducers/modal'

export default connect(
  null,
  { closeModal }
)(function ({
  closeModal,
  content,
  footerContent,
  scrollableContainer,
  noPadding,
  extraCloseButtonClass,
  closeButtonVariation
}) {
  const footer = !footerContent ? null : (
    <div className='modal__footer flex justify-center fluid-py2 bg-clear-sky-blue'>
      {footerContent}
    </div>
  )

  return (
    <>
      <Module
        extraClass='modal__dialog__module'
        padding={noPadding ? 'no-padding' : 'standard'}
        contentExtraClass={classnames('modal__container', {
          'modal__container--scrollable': scrollableContainer,
          'modal__container--no-padding': noPadding,
          'fluid-mln2 fluid-mtn2': noPadding
        })}
      >
        <div className='modal__close fluid-mr2 fluid-mt2'>
          <Button
            variation={closeButtonVariation || 'secondary'}
            action
            square
            icon='cross'
            extraClass={extraCloseButtonClass}
            onClick={closeModal}
          />
        </div>
        {content}
        {footer}
      </Module>
    </>
  )
})
